import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { IsoDateTime } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/types"
import type { StateObject } from "../../redux/types"
import { getIsSuperUser } from "../../auth/selectors"
import type { ConsoleState } from "./reducer"
import { ConsoleData } from "./types"
import { Config, Environment } from "../../../utils/config"

export const displayConsoleSection = (state: StateObject): boolean => getIsSuperUser(state)

export const displayDomainsSection = (state: StateObject): boolean => getIsSuperUser(state)

export const displayStreamingSection = (state: StateObject): boolean =>
    getIsSuperUser(state) || Config.environment === Environment.Development

export const hasWaitlistEnabled = (state: StateObject): boolean =>
    getIsSuperUser(state) || Config.environment === Environment.Development

export const getConsoleStateObject = (state: StateObject): ConsoleState => state.console

export const getRemoteScreenshotPollImageUrl = (state: StateObject): Maybe<string> =>
    getConsoleStateObject(state).remoteScreenshot.imagePollingUrl

export const getRemoteScreenshotImageUrl = (state: StateObject): Maybe<string> =>
    getConsoleStateObject(state).remoteScreenshot.imageUrl

export const isRemoteScreenshotLoading = (state: StateObject): boolean => !!getRemoteScreenshotPollImageUrl(state)

export const getConsoleLastPollingTimestamp = (state: StateObject): IsoDateTime =>
    getConsoleStateObject(state).lastPollingTimestamp

export const getConsoleData = (state: StateObject): ConsoleData[] => getConsoleStateObject(state).data

export const getOndyPlatform = (state: StateObject): string | null => getConsoleStateObject(state).ondyPlatform
